<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  items: { type: Array, default: () => [] },
  type: { type: String, required: true },
});

const { t } = useI18n();

const paymentLabel = value => {
  if (value === 'avista') return t('POST_SALE.TABLE.PAYMENT_METHODS.AVISTA');
  if (value === 'financiamento') {
    return t('POST_SALE.TABLE.PAYMENT_METHODS.FINANCIAMENTO');
  }
  if (value === 'FGTS') return t('POST_SALE.TABLE.PAYMENT_METHODS.FGTS');
  if (value === 'consorcio') {
    return t('POST_SALE.TABLE.PAYMENT_METHODS.CONSORCIO');
  }
  return '';
};

const laudemiumLabel = value => {
  if (value === 'uniao') return t('POST_SALE.TABLE.LAUDEMIUMS.UNIAO');
  if (value === 'prefeitura') return t('POST_SALE.TABLE.LAUDEMIUMS.PREFEITURA');
  if (value === 'familia') return t('POST_SALE.TABLE.LAUDEMIUMS.FAMILIA');
  if (value === 'igreja') return t('POST_SALE.TABLE.LAUDEMIUMS.IGREJA');
  return '';
};

const labelFor = value =>
  props.type === 'laudemiums' ? laudemiumLabel(value) : paymentLabel(value);
</script>

<template>
  <div class="flex flex-wrap gap-1">
    <span
      v-for="item in items"
      :key="item"
      class="rounded-full px-2 py-1 text-xs font-semibold"
      :class="
        type === 'laudemiums'
          ? 'bg-lais-primary-50 text-lais-primary'
          : 'bg-lais-bg-soft text-lais-text-body'
      "
    >
      {{ labelFor(item) }}
    </span>
  </div>
</template>
